import { api } from "api";
import type { NonIndexRouteObject } from "react-router-dom";

import ForkListRoute from "./ForkListRoute";

export const forkListRoute: NonIndexRouteObject = {
  element: <ForkListRoute />,
  loader: () => api.forks(),
};
